import React, {useEffect, useState} from 'react';
import useStyles from "../../styles/styles";
import {
    Box, Button, CircularProgress,
    Container,
    Grid,
    Modal,
    Paper,
    Typography
} from "@material-ui/core";
import RenderInput from "../TrafficSource/RenderInput";
import useFormInputs from "../../hooks/useFormInputs";
import {Alert} from '@material-ui/lab';
import ConfigFields from "./ConfigFields";

const ConfigCapacityModal = ({ data, modalData, closeModal }) => {
    const classes = useStyles();
    const [isError, setIsError] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const capFields = [{
        key: 'name',
        type: 'text',
        val: '',
        label: 'Name',
        required: true
    }, {
        key: 'limit',
        label: 'Limit',
        type: 'text',
        inputType: 'number',
        val: '',
        required: true
    },
    {
        key: 'homeState',
        label: 'Home State',
        type: 'text',
        val: '',
        required: false
    }];
    const onSubmit = () => {
        let error = false;
        setIsError(error);
        Object.keys(inputs).forEach(key => {
            const value = inputs[key];
            if (value === '' && key !== 'homeState') {
                error = true;
            }
        });
        if (!error) {
            setSubmitLoading(true);
            const { name, limit, key, category, type, homeState} = inputs;

            let newValue = {
                name,
                limit: parseFloat(limit)
            };

            // TODO Need a better way to do this, especially if the params grows. Temp solution for now
            if (homeState) {
                newValue = {
                    ...newValue,
                    'loan_request_fields': {
                        'homeState': [homeState]
                    },
                }
            }

            const newData = {
                key,
                category,
                type,
            };

            if (modalData.data.id) {
                newData.id = modalData.data.id;
            }
            if (modalData.showAddRow) {
                newValue = JSON.stringify(newValue);
                modalData.triggerCreate(newValue, newData);
            } else {
                modalData.triggerUpdate(newValue, newData);
            }
        } else {
            setIsError(true);
        }
    };
    const {inputs, handleFilterChange, handleInputChange, handleSwitchChange, handleSubmit, setInputs} = useFormInputs(onSubmit);

    useEffect(() => {
        let homeState = ""

        if(modalData.value.constraints){
            homeState = modalData.value.constraints.find((el) => el.field === "homeState")?.values[0] ?? ''
        }

        if (modalData) {
            let newInputs = {
                ...inputs,
                name: modalData.value.name || '',
                limit: modalData.value.limit || '',
                key: modalData.data.key || '',
                category: modalData.data.category || '',
            }

            if(homeState){
                newInputs = {
                    ...newInputs,
                    homeState: homeState
                }
            }

            setInputs(inputs => (newInputs));
        }
    }, [modalData]);


    return (
        <Modal
            open={true}
            onClose={closeModal}
        >
            <Container className={classes.modal} maxWidth={false}>
                <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Build the Capacity Below.
                    </Typography>
                    {isError ? (
                        <Alert severity="error">Please add values to the highlighed fields!</Alert>
                    ) : false}
                    <ConfigFields
                        inputs={inputs}
                        setInputs={setInputs}
                        data={data}
                        modalData={modalData}
                    />
                    <Grid container spacing={3} style={{marginBottom: '10px'}}>
                        <Grid item xs={12}>
                            <Typography variant="body1">
                                <Box display="flex" flexDirection="row" alignItems="center">
                                    <strong>Capacity Fields</strong>
                                </Box>
                            </Typography>
                        </Grid>
                        {capFields.map(item => {
                            const { key } = item;
                            return (
                                <Grid key={key} item xs={4}>
                                    <RenderInput
                                        item={item}
                                        value={inputs[key] || ''}
                                        data={data}
                                        handleFilterChange={handleFilterChange}
                                        handleInputChange={handleInputChange}
                                        handleSwitchChange={handleSwitchChange}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        style={{margin: '10px 0'}}
                        justifyContent={"center"}>
                        <Box style={{marginRight: '10px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    handleSubmit();
                                }}
                                disabled={submitLoading}
                            >
                                {submitLoading ? (
                                    <CircularProgress color="inherit"/>
                                ) : (
                                    <>
                                        Save Values
                                    </>
                                )}
                            </Button>
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    closeModal();
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Modal>
    );
};

export default ConfigCapacityModal;
